import React, { useContext, useEffect, useLayoutEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { getMetaTags } from "./utils/meta-tags";

import Routes from "./Routes";
import { AppContext, AppContextInterface } from "./state/ContextProvider";
import { ErrorPage, ErrorLog } from "./pages/Error/Error";
import { Header } from "./components/common/header/Header";
import { Container } from "./components/common/container/Container";
import Footer from "./components/footer/Footer";
import TagManager from "react-gtm-module";

const App: React.FC = () => {
  const {
    state: { groupId },
  } = useContext(AppContext) as AppContextInterface;

  type TagIds = {
    gtmIdGroup1: string;
    gtmIdGroup2: string;
    gtmIdGroup3: string;
  };

  type GtmProperties = {
    gtmId: string;
  };

  const tags: TagIds = {
    gtmIdGroup1: "GTM-PJJ7HKS",
    gtmIdGroup2: "GTM-5X9PQGX",
    gtmIdGroup3: "GTM-NT6GG79",
  };

  const getSelectedTag = (tagIds: TagIds, id: number): GtmProperties => {
    switch (id) {
      case 1:
        return { gtmId: tagIds.gtmIdGroup1 };
      case 2:
        return { gtmId: tagIds.gtmIdGroup2 };
      case 3:
        return { gtmId: tagIds.gtmIdGroup3 };
      default:
        return { gtmId: tagIds.gtmIdGroup1 };
    }
  };

  useLayoutEffect(() => {
    getMetaTags();
  }, []);

  useEffect(() => {
    if (groupId && groupId !== 0) {
      const gtmProperties = getSelectedTag(tags, groupId);
      TagManager.dataLayer({ dataLayer: gtmProperties });
      TagManager.initialize(gtmProperties);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId]);

  return (
    <>
      <Container>
        <Header groupId={groupId} />
        <ErrorBoundary FallbackComponent={ErrorPage} onError={ErrorLog}>
          <Router basename={`click-and-sell`}>
            <Routes />
          </Router>
        </ErrorBoundary>
      </Container>
      <Footer groupId={groupId} />
    </>
  );
};

export default App;
